import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

import './dropDownMenu.scss';

const DropDownMenu = (props) => {
  const dispatch = useDispatch();
  const [click, setClick] = useState(false);
  const pageLanguageContents = props.content
  const cardExpiryDetails = useSelector(state => state.authReducer.cardExpiryDetails)
  let isSubscriptionCardExpired = cardExpiryDetails.subscriptionCardExpired

  const storedData = useSelector(
    (state) => state.storedData.payload
  );
  let disableFlg = storedData?.guestUser
  let MenuItems;
  if (localStorage.getItem('accountType') === "Buyer" && !disableFlg) {
    MenuItems = [
      {
        title: pageLanguageContents?.Header[1]?.H2_Postoffers,
        path: '/nearby-inventory',
        cName: 'dropdown-link',
        // cName: 'dropdown-link event-li',
        disableFlag: false,
        type: 'SearchPostScreen'
      },
      {
        title: pageLanguageContents?.Header[4]?.H5_Orders,
        path: '/my-orders',
        cName: 'dropdown-link',
        // cName: 'dropdown-link event-li',
        disableFlag: false,
        type: 'MyOrder'
      },
      {
        title: pageLanguageContents?.Header[5]?.H6_Resolution,
        path: '/resolution-center',
        cName: 'dropdown-link',
        // cName: 'dropdown-link event-li',
        disableFlag: false,
        // disableFlag:disableFlg ==='true'?true:false,
        type: 'Resolution'
      },
      {
        title: pageLanguageContents?.Header[2]?.H3_Community,
        path: '/my-community',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: disableFlg ? true : false,
        type: 'MyCommunity'
      },
      {
        title: pageLanguageContents?.Header[11]?.H8_Nav_Orders,
        path: '/order-reports',
        cName: 'dropdown-link',// event-li
        disableFlag: false,
        type: 'orderReportsFront'
      },
      {
        title: 'Pallet Spec Library',
        path: '/specifications',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: false,
        type: 'Specification'
      },
      {
        title: 'Operational T&C',
        path: '/operational-terms-and-conditions',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: false,
        type: 'Opertaional'
      },
      {
        title: pageLanguageContents?.Header[12]?.H8_Nav_Logout,
        path: '/sign-in',
        cName: 'dropdown-link',
        disableFlag: false,
        type: 'Auth'
      }
    ];
  } else if (localStorage.getItem('accountType') === "Seller" && !disableFlg) {
    MenuItems = [
      {
        title: pageLanguageContents?.Header[0]?.H1_Palletneeds,
        path: '/nearby-needs',
        // cName: 'dropdown-link event-li',  
        cName: 'dropdown-link',
        disableFlag: disableFlg ? true : false,
        type: 'SearchPostLoadScreen'
      },
      {
        title: pageLanguageContents?.Header[4]?.H5_Orders,
        path: '/my-orders',
        cName: 'dropdown-link',
        // cName: 'dropdown-link event-li',
        disableFlag: false,
        type: 'MyOrder'
      },
      {
        title: pageLanguageContents?.Header[5]?.H6_Resolution,
        path: '/resolution-center',
        cName: 'dropdown-link',
        // cName: 'dropdown-link event-li',
        disableFlag: false,
        // disableFlag:disableFlg ==='true'?true:false,
        type: 'Resolution'
      },
      {
        title: pageLanguageContents?.Header[2]?.H3_Community,
        path: '/my-community',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: disableFlg ? true : false,
        type: 'MyCommunity'
      },
      {
        title: pageLanguageContents?.Header[11]?.H8_Nav_Orders,
        path: '/order-reports',
        cName: 'dropdown-link',// event-li
        disableFlag: false,
        type: 'orderReportsFront'
      },
      {
        title: 'Pallet Spec Library',
        path: '/specifications',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: false,
        type: 'Specification'
      },
      {
        title: 'Operational T&C',
        path: '/operational-terms-and-conditions',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: false,
        type: 'Opertaional'
      },
      {
        title: pageLanguageContents?.Header[12]?.H8_Nav_Logout,
        path: '/sign-in',
        cName: 'dropdown-link',
        disableFlag: false,
        type: 'Auth'
      }
    ];
  } else {
    MenuItems = [
      {
        title: pageLanguageContents?.Header[0]?.H1_Palletneeds,
        path: '/nearby-needs',
        // cName: 'dropdown-link event-li',  
        cName: 'dropdown-link',
        disableFlag: disableFlg ? true : false,
        type: 'SearchPostLoadScreen'
      },
      {
        title: pageLanguageContents?.Header[1]?.H2_Postoffers,
        path: '/nearby-inventory',
        cName: 'dropdown-link',
        // cName: 'dropdown-link event-li',
        disableFlag: false,
        type: 'SearchPostScreen'
      },
      {
        title: pageLanguageContents?.Header[4]?.H5_Orders,
        path: '/my-orders',
        cName: 'dropdown-link',
        // cName: 'dropdown-link event-li',
        disableFlag: false,
        type: 'MyOrder'
      },
      {
        title: pageLanguageContents?.Header[5]?.H6_Resolution,
        path: '/resolution-center',
        cName: 'dropdown-link',
        // cName: 'dropdown-link event-li',
        disableFlag: false,
        // disableFlag:disableFlg ==='true'?true:false,
        type: 'Resolution'
      },
      {
        title: pageLanguageContents?.Header[2]?.H3_Community,
        path: '/my-community',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: disableFlg ? true : false,
        type: 'MyCommunity'
      },
      {
        title: pageLanguageContents?.Header[11]?.H8_Nav_Orders,
        path: '/order-reports',
        cName: 'dropdown-link',// event-li
        disableFlag: false,
        type: 'orderReportsFront'
      },
      {
        title: 'Pallet Spec Library',
        path: '/specifications',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: false,
        type: 'Specification'
      },
      {
        title: 'Operational T&C',
        path: '/operational-terms-and-conditions',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        disableFlag: false,
        type: 'Opertaional'
      },
      {
        title: pageLanguageContents?.Header[12]?.H8_Nav_Logout,
        path: '/sign-in',
        cName: 'dropdown-link',
        disableFlag: false,
        type: 'Auth'
      }
    ];
  }

  const onLinkClick = (type) => {
    if (type === 'SearchPostLoadScreen') {
      let obj = {
        title:'',
        params: 'true',
        pageType: "PostLoad",
        expanded: 'sideBar'
      }
      dispatch({ type: 'SEARCH_POST', payload: obj })
    }

    if (type === 'SearchPostScreen') {
      let obj = {
        title: '',
        params: 'true',
        pageType: "PostInventory",
        expanded: 'sideBar'
      }
      dispatch({ type: 'SEARCH_INVENTORY', payload: obj })
    }
    if (type === 'MyOrder') {
      let obj = {
        pageType: "MyOrder",
        expanded: 'sideBar'
      }
      dispatch({ type: 'ORDERS', payload: obj })
      let myOrderSelectedPageObj = {
        myOrderSelectedPage: 1,
      }
      dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
    }
    if (type === 'MyCommunity') {
      let obj = {
        pageType: "MyCommunity",
      }
      dispatch({ type: 'MYCOMMUNITY', payload: obj })
    }
    if (type === 'Faq') {
      let obj = {
        pageType: "Faq",
      }
      dispatch({ type: 'FAQ', payload: obj })
    }
    if (type === 'Resolution') {
      let obj = {
        pageType: "ClaimRaise",
        expanded: "sideBar"
      }
      dispatch({ type: 'RESOLUTION_CENTER', payload: obj })
    }
    if (type === 'Auth') {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  };
  return (
    <>
      <ul
        className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>

              {item.disableFlag ?
                <div
                  className="opacityDisable"
                >
                  <img
                    className="arrow-image"
                    src={HoverRightArrow}
                    alt="right-arrow"
                  />
                  {item.title}
                </div> :
                <Link
                  className={item.cName}
                  exact
                  to={item.path}
                  onClick={() => onLinkClick(item.type)}
                >
                  <img
                    className="arrow-image"
                    src={HoverRightArrow}
                    alt="right-arrow"
                  />
                  {item.title}
                </Link>}
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropDownMenu;